import { OrganisationCard } from "./CRUDs/entities/OrganisationCard";
import { EntityModalForm } from "./CRUDs/abstracts/mixins/EntityModalForm";
import { SaveButton } from "./components/SaveButton";

export default {

    orgId:null,
    step:1,
    texts:[
        'Creating your organization.',
        'Configuring your services.',
        'Setting the stage for your success.',
        'Building your starter website.'
    ],
    startTextRepl:false,
    timeout:null,
    nextText:null,
    replIndex:0,

    init(){
        let saveButton = new SaveButton('#create-org-form')
        $('body').off('click', '#create-org-page #btn-create-edit-org')
        .on('click', '#create-org-page #btn-create-edit-org', (ev)=>{
            let url = $(ev.target).data('route')
            let form = $('#create-org-form')
            $('#create-org-loader').addClass('active')
            this.replaceTextAndGif(false, true)
            let data = new FormData(form[0])
            if(this.orgId)
                data.append('org_id', this.orgId)
            let $this = this
            $.ajax({
                type: 'POST',
                url: url,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                beforeSend:()=>{
                    saveButton.startLoading()
                },
                success: function(response) {
                    if(response?.org_id)
                        $this.orgId = response?.org_id
                    if(!response?.success){
                        if (response?.card_required) {
                            const planId = $('#create-org-form input[name="plan"]').val()
                            const staticCard = new OrganisationCard(null, { accept_plan_id: planId, is_new_org:true });
                            staticCard.successSubmitCallback = ()=>{
                                window.location.replace(window.location.origin+'/dashboard')
                            }
                            staticCard.openModal('create',{is_new_org:true});
                        } else if (response?.modal) {
                            const formHTML = response.modal;
                            EntityModalForm.pasteForm(formHTML);
                            $('.modal-backdrop').first().remove();
                            $('#failed-action-modal').modal('show');
                        }
                        $('#create-org-loader').removeClass('active')
                        clearTimeout($this.timeout)
                    }else{
                        if(response?.redirect){
                            window.location.replace(response?.redirect)
                        }else{
                            window.location.replace(window.location.origin+'/dashboard')
                        }
                    }
                    saveButton.stopLoading(false,'Create')
                },
                error:()=>{
                    $('#create-org-loader').removeClass('active')
                    clearTimeout($this.timeout)
                    saveButton.stopLoading(false,'Create')
                }
            });
        })
    },
    
    replaceTextAndGif(revert = false, restart=false) {
        let gifWrapper = document.getElementById('gif-wrapper')
        let textEl = document.getElementById('load-text');
        if(restart){
            gifWrapper.style.transform=''
            this.step=1
            this.startTextRepl = false
            textEl.innerText = this.texts[0]
            this.timeout = setTimeout(()=>this.replaceTextAndGif(),3000)
            return
        }
       
        let currTxt = textEl.innerText;
        let index = currTxt.indexOf('*')
        if (index == -1 && this.startTextRepl) {
            this.startTextRepl = false;
            this.timeout = setTimeout(() => this.replaceTextAndGif(), 3000)
            return;
        }
        if (!this.startTextRepl) {
            if (this.step >= this.texts.length)
                this.step = 1
            this.nextText = this.texts[this.step];
            gifWrapper.style.transform = `translateX(-${this.step*100}%)`
            this.startTextRepl = true;
            this.replIndex = 0
            this.step++;
        }
        let len = currTxt.length > this.nextText.length ? currTxt.length : this.nextText.length
        if (this.replIndex == len) {
            this.replIndex = 0
            revert = true
        }
        currTxt = Array.from(currTxt)
        if (revert) {
            if (this.replIndex >= this.nextText.length)
                currTxt.splice(this.replIndex, 1)
            else {
                currTxt.splice(this.replIndex, 1, this.nextText[this.replIndex])
                this.replIndex++;
            }
        } else {
            currTxt.splice(this.replIndex, 1, '*')
            this.replIndex++;
        }
        textEl.innerText = currTxt.join('')
        this.timeout = setTimeout(() => this.replaceTextAndGif(revert), 20)
    },
}